// src/configuration/configuration-enums.ts
var OnlineBookingMode = /* @__PURE__ */ ((OnlineBookingMode2) => {
  OnlineBookingMode2["AUTO_ACCEPT"] = "auto_accept";
  OnlineBookingMode2["AUTO_ACCEPT_ASSIGN"] = "auto_accept_assign";
  OnlineBookingMode2["MANUAL"] = "manual";
  return OnlineBookingMode2;
})(OnlineBookingMode || {});
var BookingBehaviorMode = /* @__PURE__ */ ((BookingBehaviorMode2) => {
  BookingBehaviorMode2["MANUAL"] = "manual";
  BookingBehaviorMode2["AUTO"] = "auto";
  BookingBehaviorMode2["AI"] = "ai";
  return BookingBehaviorMode2;
})(BookingBehaviorMode || {});
var OutcomeTrackingMode = /* @__PURE__ */ ((OutcomeTrackingMode2) => {
  OutcomeTrackingMode2["AUTO"] = "auto";
  OutcomeTrackingMode2["MANUAL"] = "manual";
  return OutcomeTrackingMode2;
})(OutcomeTrackingMode || {});
var ServiceSelectionMode = /* @__PURE__ */ ((ServiceSelectionMode2) => {
  ServiceSelectionMode2["SINGLE"] = "single";
  ServiceSelectionMode2["MULTIPLE"] = "multiple";
  return ServiceSelectionMode2;
})(ServiceSelectionMode || {});
var WorkerSelectionMode = /* @__PURE__ */ ((WorkerSelectionMode2) => {
  WorkerSelectionMode2["PRIMARY_SERVICE"] = "primary_service";
  WorkerSelectionMode2["ALL_SERVICES"] = "all_services";
  WorkerSelectionMode2["INDIVIDUAL_ASSIGNMENT"] = "individual_assignment";
  return WorkerSelectionMode2;
})(WorkerSelectionMode || {});
var NotificationChannel = /* @__PURE__ */ ((NotificationChannel2) => {
  NotificationChannel2["EMAIL"] = "email";
  NotificationChannel2["SMS"] = "sms";
  NotificationChannel2["WHATSAPP"] = "whatsapp";
  return NotificationChannel2;
})(NotificationChannel || {});

// src/configuration/configuration-defaults.ts
var CONFIG_DEFAULTS = {
  // Appointment Limits
  "appointment_limits.capacity_mode": "simple",
  "appointment_limits.concurrent_max": 10,
  "appointment_limits.daily_max": 100,
  "appointment_limits.concurrent_infinity": true,
  "appointment_limits.daily_infinity": true,
  "appointment_limits.duration_aware": true,
  // Appointment Buffer
  "appointment_buffer.preparation_time": 0,
  "appointment_buffer.cleanup_time": 0,
  // Loyalty
  "loyalty.points_per_dollar": 1,
  "loyalty.points_per_visit": 0,
  // No visit points by default
  "loyalty.enabled": false,
  "loyalty.minimum_spend_threshold": 0,
  // $0 minimum, always earn points
  // Online Booking Configuration
  "online_booking.enabled": true,
  "online_booking.slots_per_hour": 2,
  "online_booking.lead_minutes_from_now": 0,
  "online_booking.lead_minutes_from_opening": 30,
  "online_booking.trail_minutes_before_closing": 60,
  "online_booking.mode": "manual" /* MANUAL */,
  "online_booking.waiting_list_enabled": false,
  "online_booking.advance_booking_days": 30,
  "online_booking.worker_selection_enabled": true,
  "online_booking.service_selection_mode": "multiple" /* MULTIPLE */,
  "online_booking.worker_selection_mode": "primary_service" /* PRIMARY_SERVICE */,
  "online_booking.allow_booking_past_closing": false,
  "online_booking.show_service_duration": true,
  "online_booking.bank_transfer_enabled": true,
  // Booking Behavior Configuration
  "booking_behavior.mode": "manual" /* MANUAL */,
  "booking_behavior.manual.count_pending_toward_capacity": false,
  "booking_behavior.auto.arrange_workers": true,
  "booking_behavior.auto.confirm_immediately": true,
  "booking_behavior.auto.batch_confirm_interval": 15,
  "booking_behavior.ai.natural_language_rules": "",
  "booking_behavior.ai.smart_gap_filling": true,
  "booking_behavior.ai.service_recommendations": true,
  // Salon Configuration
  "salon.appointment_worker_assignment_enabled": false,
  "salon.outcome_tracking_enabled": true,
  "salon.outcome_tracking_mode": "auto" /* AUTO */,
  "salon.loyalty_program_enabled": true,
  // Notification Limits (-1 = unlimited)
  "notification_limits.email_monthly_limit": -1,
  "notification_limits.sms_monthly_limit": 0,
  "notification_limits.whatsapp_monthly_limit": 0,
  // Customer Notification Chains (external - sent to customers)
  "customer_notifications.appointment_confirmation_chain": [["email"]],
  "customer_notifications.appointment_reminder_chain": [["email"]],
  "customer_notifications.waitlist_approved_chain": [["email"]],
  "customer_notifications.fallback_delay_ms": 5e3,
  "customer_notifications.max_chain_length": 4,
  // User Notification Chains (internal - sent to salon staff)
  "user_notifications.new_appointment_chain": [["email"], ["push"]],
  "user_notifications.appointment_cancelled_chain": [["email"], ["push"]],
  "user_notifications.daily_summary_chain": [["email"], ["push"]],
  "user_notifications.fallback_delay_ms": 3e3,
  "user_notifications.max_chain_length": 3,
  // Premium Features
  "premium_features.appointment_history_limit_days": 3,
  "premium_features.customer_query_limit_enabled": true,
  "premium_features.reports_access_limit_enabled": true,
  "premium_features.ai_chat_enabled": false,
  "premium_features.ai_monthly_credit_default": 0,
  // UI Feature Flags
  "ui.report.enabled": true
};
var CONFIG_STRING_DEFAULTS = {
  // Appointment Limits
  "appointment_limits.capacity_mode": "simple",
  "appointment_limits.concurrent_max": "10",
  "appointment_limits.daily_max": "100",
  "appointment_limits.concurrent_infinity": "true",
  "appointment_limits.daily_infinity": "true",
  "appointment_limits.duration_aware": "true",
  // Appointment Buffer
  "appointment_buffer.preparation_time": "0",
  "appointment_buffer.cleanup_time": "0",
  // Loyalty
  "loyalty.points_per_dollar": "1",
  "loyalty.points_per_visit": "0",
  "loyalty.enabled": "false",
  "loyalty.minimum_spend_threshold": "0",
  // Online Booking Configuration
  "online_booking.enabled": "true",
  "online_booking.slots_per_hour": "2",
  "online_booking.lead_minutes_from_now": "0",
  "online_booking.lead_minutes_from_opening": "30",
  "online_booking.trail_minutes_before_closing": "60",
  "online_booking.mode": "manual" /* MANUAL */,
  "online_booking.waiting_list_enabled": "false",
  "online_booking.advance_booking_days": "30",
  "online_booking.worker_selection_enabled": "true",
  "online_booking.service_selection_mode": "multiple" /* MULTIPLE */,
  "online_booking.worker_selection_mode": "primary_service" /* PRIMARY_SERVICE */,
  "online_booking.allow_booking_past_closing": "false",
  "online_booking.show_service_duration": "true",
  "online_booking.bank_transfer_enabled": "true",
  // Booking Behavior Configuration
  "booking_behavior.mode": "manual" /* MANUAL */,
  "booking_behavior.manual.count_pending_toward_capacity": "false",
  "booking_behavior.auto.arrange_workers": "true",
  "booking_behavior.auto.confirm_immediately": "true",
  "booking_behavior.auto.batch_confirm_interval": "15",
  "booking_behavior.ai.natural_language_rules": "",
  "booking_behavior.ai.smart_gap_filling": "true",
  "booking_behavior.ai.service_recommendations": "true",
  // Salon Configuration
  "salon.appointment_worker_assignment_enabled": "false",
  "salon.outcome_tracking_enabled": "true",
  "salon.outcome_tracking_mode": "auto" /* AUTO */,
  "salon.loyalty_program_enabled": "true",
  // Notification Limits (-1 = unlimited)
  "notification_limits.email_monthly_limit": "-1",
  "notification_limits.sms_monthly_limit": "0",
  "notification_limits.whatsapp_monthly_limit": "0",
  // Customer Notification Chains (external - sent to customers)
  "customer_notifications.appointment_confirmation_chain": '[["email"]]',
  "customer_notifications.appointment_reminder_chain": '[["email"]]',
  "customer_notifications.waitlist_approved_chain": '[["email"]]',
  "customer_notifications.fallback_delay_ms": "5000",
  "customer_notifications.max_chain_length": "4",
  // User Notification Chains (internal - sent to salon staff)
  "user_notifications.new_appointment_chain": '[["email"], ["push"]]',
  "user_notifications.appointment_cancelled_chain": '[["email"], ["push"]]',
  "user_notifications.daily_summary_chain": '[["email"], ["push"]]',
  "user_notifications.fallback_delay_ms": "3000",
  "user_notifications.max_chain_length": "3",
  // Premium Features
  "premium_features.appointment_history_limit_days": "3",
  "premium_features.customer_query_limit_enabled": "true",
  "premium_features.reports_access_limit_enabled": "true",
  "premium_features.ai_chat_enabled": "false",
  "premium_features.ai_monthly_credit_default": "0",
  // UI Feature Flags
  "ui.report.enabled": "true"
};
var CONFIG_CATEGORIES = {
  APPOINTMENT_LIMITS: "appointment_limits",
  BOOKING_POLICY: "booking_policy",
  APPOINTMENT_BUFFER: "appointment_buffer",
  LOYALTY: "loyalty",
  ONLINE_BOOKING: "online_booking",
  BOOKING_BEHAVIOR: "booking_behavior",
  SALON: "salon",
  NOTIFICATION_LIMITS: "notification_limits",
  CUSTOMER_NOTIFICATIONS: "customer_notifications",
  USER_NOTIFICATIONS: "user_notifications",
  PREMIUM_FEATURES: "premium_features",
  UI: "ui"
};
var UNLIMITED_CAPACITY = 999;

// src/configuration/configuration-keys.ts
var CONFIG_KEYS = {
  APPOINTMENT_LIMITS: {
    CAPACITY_MODE: "appointment_limits.capacity_mode",
    CONCURRENT_MAX: "appointment_limits.concurrent_max",
    DAILY_MAX: "appointment_limits.daily_max",
    CONCURRENT_INFINITY: "appointment_limits.concurrent_infinity",
    DAILY_INFINITY: "appointment_limits.daily_infinity",
    DURATION_AWARE: "appointment_limits.duration_aware"
  },
  APPOINTMENT_BUFFER: {
    PREPARATION_TIME: "appointment_buffer.preparation_time",
    CLEANUP_TIME: "appointment_buffer.cleanup_time"
  },
  LOYALTY: {
    POINTS_PER_DOLLAR: "loyalty.points_per_dollar",
    POINTS_PER_VISIT: "loyalty.points_per_visit",
    ENABLED: "loyalty.enabled",
    MINIMUM_SPEND_THRESHOLD: "loyalty.minimum_spend_threshold"
  },
  ONLINE_BOOKING: {
    ENABLED: "online_booking.enabled",
    SLOTS_PER_HOUR: "online_booking.slots_per_hour",
    LEAD_MINUTES_FROM_NOW: "online_booking.lead_minutes_from_now",
    LEAD_MINUTES_FROM_OPENING: "online_booking.lead_minutes_from_opening",
    TRAIL_MINUTES_BEFORE_CLOSING: "online_booking.trail_minutes_before_closing",
    MODE: "online_booking.mode",
    WAITING_LIST_ENABLED: "online_booking.waiting_list_enabled",
    ADVANCE_BOOKING_DAYS: "online_booking.advance_booking_days",
    WORKER_SELECTION_ENABLED: "online_booking.worker_selection_enabled",
    SERVICE_SELECTION_MODE: "online_booking.service_selection_mode",
    WORKER_SELECTION_MODE: "online_booking.worker_selection_mode",
    ALLOW_BOOKING_PAST_CLOSING: "online_booking.allow_booking_past_closing",
    SHOW_SERVICE_DURATION: "online_booking.show_service_duration",
    BANK_TRANSFER_ENABLED: "online_booking.bank_transfer_enabled"
  },
  BOOKING_BEHAVIOR: {
    MODE: "booking_behavior.mode",
    MANUAL_COUNT_PENDING_TOWARD_CAPACITY: "booking_behavior.manual.count_pending_toward_capacity",
    AUTO_ARRANGE_WORKERS: "booking_behavior.auto.arrange_workers",
    AUTO_CONFIRM_IMMEDIATELY: "booking_behavior.auto.confirm_immediately",
    AUTO_BATCH_CONFIRM_INTERVAL: "booking_behavior.auto.batch_confirm_interval",
    AI_NATURAL_LANGUAGE_RULES: "booking_behavior.ai.natural_language_rules",
    AI_SMART_GAP_FILLING: "booking_behavior.ai.smart_gap_filling",
    AI_SERVICE_RECOMMENDATIONS: "booking_behavior.ai.service_recommendations"
  },
  SALON: {
    APPOINTMENT_WORKER_ASSIGNMENT_ENABLED: "salon.appointment_worker_assignment_enabled",
    OUTCOME_TRACKING_ENABLED: "salon.outcome_tracking_enabled",
    OUTCOME_TRACKING_MODE: "salon.outcome_tracking_mode",
    LOYALTY_PROGRAM_ENABLED: "salon.loyalty_program_enabled"
  },
  NOTIFICATION_LIMITS: {
    EMAIL_MONTHLY_LIMIT: "notification_limits.email_monthly_limit",
    SMS_MONTHLY_LIMIT: "notification_limits.sms_monthly_limit",
    WHATSAPP_MONTHLY_LIMIT: "notification_limits.whatsapp_monthly_limit"
  },
  PREMIUM_FEATURES: {
    APPOINTMENT_HISTORY_LIMIT_DAYS: "premium_features.appointment_history_limit_days",
    CUSTOMER_QUERY_LIMIT_ENABLED: "premium_features.customer_query_limit_enabled",
    REPORTS_ACCESS_LIMIT_ENABLED: "premium_features.reports_access_limit_enabled",
    AI_CHAT_ENABLED: "premium_features.ai_chat_enabled",
    AI_MONTHLY_CREDIT_DEFAULT: "premium_features.ai_monthly_credit_default"
  },
  UI: {
    REPORT_ENABLED: "ui.report.enabled"
  }
};
function isValidConfigurationKey(key) {
  return key in CONFIG_DEFAULTS_MAP;
}
var ALL_CONFIG_KEYS = Object.values(CONFIG_KEYS).flatMap(
  (category) => Object.values(category)
);
var CONFIG_DEFAULTS_MAP = {
  // Appointment Limits
  "appointment_limits.capacity_mode": "simple",
  "appointment_limits.concurrent_max": 4,
  "appointment_limits.daily_max": 50,
  "appointment_limits.concurrent_infinity": false,
  "appointment_limits.daily_infinity": false,
  "appointment_limits.duration_aware": true,
  // Appointment Buffer
  "appointment_buffer.preparation_time": 5,
  "appointment_buffer.cleanup_time": 5,
  // Loyalty
  "loyalty.points_per_dollar": 1,
  "loyalty.points_per_visit": 0,
  "loyalty.enabled": true,
  "loyalty.minimum_spend_threshold": 0,
  // Online Booking
  "online_booking.enabled": true,
  "online_booking.slots_per_hour": 2,
  "online_booking.lead_minutes_from_now": 0,
  "online_booking.lead_minutes_from_opening": 15,
  "online_booking.trail_minutes_before_closing": 15,
  "online_booking.mode": "auto_accept" /* AUTO_ACCEPT */,
  "online_booking.waiting_list_enabled": true,
  "online_booking.advance_booking_days": 30,
  "online_booking.worker_selection_enabled": true,
  "online_booking.service_selection_mode": "single" /* SINGLE */,
  "online_booking.worker_selection_mode": "primary_service" /* PRIMARY_SERVICE */,
  "online_booking.allow_booking_past_closing": false,
  "online_booking.show_service_duration": true,
  "online_booking.bank_transfer_enabled": true,
  // Booking Behavior
  "booking_behavior.mode": "manual" /* MANUAL */,
  "booking_behavior.manual.count_pending_toward_capacity": false,
  "booking_behavior.auto.arrange_workers": true,
  "booking_behavior.auto.confirm_immediately": true,
  "booking_behavior.auto.batch_confirm_interval": 15,
  "booking_behavior.ai.natural_language_rules": "",
  "booking_behavior.ai.smart_gap_filling": true,
  "booking_behavior.ai.service_recommendations": true,
  // Salon
  "salon.appointment_worker_assignment_enabled": true,
  "salon.outcome_tracking_enabled": true,
  "salon.outcome_tracking_mode": "auto" /* AUTO */,
  "salon.loyalty_program_enabled": true,
  // Notification Limits (-1 = unlimited)
  "notification_limits.email_monthly_limit": -1,
  "notification_limits.sms_monthly_limit": 100,
  "notification_limits.whatsapp_monthly_limit": 50,
  // User Notifications
  "user_notifications.new_appointment_chain": [["email"]],
  "user_notifications.appointment_cancelled_chain": [["email"]],
  "user_notifications.daily_summary_chain": [["email"]],
  "user_notifications.fallback_delay_ms": 1e3,
  "user_notifications.max_chain_length": 5,
  // Customer Notifications
  "customer_notifications.appointment_confirmation_chain": [["email"]],
  "customer_notifications.appointment_reminder_chain": [["email"]],
  "customer_notifications.waitlist_approved_chain": [["email"]],
  "customer_notifications.fallback_delay_ms": 1e3,
  "customer_notifications.max_chain_length": 5,
  // Premium Features
  "premium_features.appointment_history_limit_days": 3,
  "premium_features.customer_query_limit_enabled": true,
  "premium_features.reports_access_limit_enabled": true,
  "premium_features.ai_chat_enabled": false,
  "premium_features.ai_monthly_credit_default": 0,
  // UI Feature Flags
  "ui.report.enabled": true
};

// src/configuration/configuration-sections.ts
var CONFIG_SECTIONS = [
  {
    id: "salon-config",
    order: 1,
    configKeys: [
      "salon.appointment_worker_assignment_enabled",
      "salon.outcome_tracking_enabled",
      "salon.outcome_tracking_mode"
    ]
  },
  {
    id: "online-booking",
    order: 2,
    configKeys: [
      "online_booking.enabled",
      "online_booking.slots_per_hour",
      "online_booking.lead_minutes_from_now",
      "online_booking.lead_minutes_from_opening",
      "online_booking.trail_minutes_before_closing",
      "online_booking.advance_booking_days",
      "online_booking.worker_selection_enabled",
      "online_booking.service_selection_mode",
      "online_booking.show_service_duration",
      "online_booking.bank_transfer_enabled"
    ]
  },
  {
    id: "booking-behavior",
    order: 3,
    configKeys: [
      "booking_behavior.mode",
      "booking_behavior.manual.count_pending_toward_capacity",
      "booking_behavior.auto.arrange_workers",
      "booking_behavior.auto.confirm_immediately",
      "booking_behavior.auto.batch_confirm_interval"
    ]
  },
  {
    id: "appointment-limits",
    order: 4,
    configKeys: [
      "appointment_limits.capacity_mode",
      "appointment_limits.concurrent_max",
      "appointment_limits.daily_max",
      "appointment_limits.concurrent_infinity",
      "appointment_limits.daily_infinity",
      "appointment_limits.duration_aware"
    ]
  },
  {
    id: "dashboard-features",
    order: 5,
    configKeys: ["ui.report.enabled"]
  }
];
function getConfigurationSection(id) {
  const section = CONFIG_SECTIONS.find((s) => s.id === id);
  if (!section) {
    throw new Error(`Unknown configuration section: ${id}`);
  }
  return section;
}

// src/configuration/configuration-types.ts
var ConfigurationType = /* @__PURE__ */ ((ConfigurationType2) => {
  ConfigurationType2["REGULAR"] = "regular";
  ConfigurationType2["PREMIUM"] = "premium";
  return ConfigurationType2;
})(ConfigurationType || {});
var PREMIUM_CONFIGURATION_KEYS = [
  "notification_limits.email_monthly_limit",
  "notification_limits.sms_monthly_limit",
  "notification_limits.whatsapp_monthly_limit",
  "premium_features.appointment_history_limit_days",
  "premium_features.customer_query_limit_enabled",
  "premium_features.reports_access_limit_enabled",
  "premium_features.ai_chat_enabled"
];
function getConfigurationType(key) {
  return PREMIUM_CONFIGURATION_KEYS.includes(key) ? "premium" /* PREMIUM */ : "regular" /* REGULAR */;
}
function isPremiumConfiguration(key) {
  return PREMIUM_CONFIGURATION_KEYS.includes(key);
}
function getPremiumConfigurationKeys() {
  return PREMIUM_CONFIGURATION_KEYS;
}

// src/configuration/configuration-utils.ts
var ENUM_VALUES = {
  "booking_behavior.mode": Object.values(BookingBehaviorMode),
  "online_booking.mode": Object.values(OnlineBookingMode),
  "salon.outcome_tracking_mode": Object.values(OutcomeTrackingMode),
  "online_booking.service_selection_mode": Object.values(ServiceSelectionMode),
  "online_booking.worker_selection_mode": Object.values(WorkerSelectionMode),
  "appointment_limits.capacity_mode": ["simple", "advanced"]
};
function parseConfigurationValue(key, stringValue) {
  const defaultValue = CONFIG_DEFAULTS[key];
  if (typeof defaultValue === "number") {
    const parsed = parseInt(stringValue, 10);
    return Number.isNaN(parsed) ? defaultValue : parsed;
  } else if (typeof defaultValue === "boolean") {
    return stringValue.toLowerCase() === "true";
  } else if (Array.isArray(defaultValue)) {
    return JSON.parse(stringValue);
  } else {
    const allowedValues = ENUM_VALUES[key];
    if (allowedValues) {
      const normalized = stringValue.toLowerCase();
      if (allowedValues.includes(normalized)) {
        return normalized;
      }
      return defaultValue;
    }
    return stringValue;
  }
}
function serializeConfigurationValue(_key, value) {
  if (Array.isArray(value)) {
    return value.join(",");
  } else {
    return String(value);
  }
}
function validateConfigurationValue(key, value) {
  const defaultValue = CONFIG_DEFAULTS[key];
  if (typeof defaultValue === "number") {
    return typeof value === "number" && !Number.isNaN(value);
  } else if (typeof defaultValue === "boolean") {
    return typeof value === "boolean";
  } else if (Array.isArray(defaultValue)) {
    return Array.isArray(value) && value.every((item) => typeof item === "string");
  } else {
    if (typeof value !== "string") {
      return false;
    }
    const allowedValues = ENUM_VALUES[key];
    if (allowedValues) {
      return allowedValues.includes(value);
    }
    return true;
  }
}
function getAllowedEnumValues(key) {
  return ENUM_VALUES[key];
}
function getCategoryFromKey(key) {
  const parts = key.split(".");
  return parts[0] || "general";
}
function getDataTypeFromKey(key) {
  const defaultValue = CONFIG_DEFAULTS[key];
  if (typeof defaultValue === "number") {
    return "int";
  } else if (typeof defaultValue === "boolean") {
    return "boolean";
  } else if (Array.isArray(defaultValue)) {
    return "string";
  } else if (key.includes("time") || key.includes("cutoff")) {
    return "time";
  } else {
    return "string";
  }
}
export {
  ALL_CONFIG_KEYS,
  BookingBehaviorMode,
  CONFIG_CATEGORIES,
  CONFIG_DEFAULTS,
  CONFIG_KEYS,
  CONFIG_SECTIONS,
  CONFIG_STRING_DEFAULTS,
  ConfigurationType,
  NotificationChannel,
  OnlineBookingMode,
  OutcomeTrackingMode,
  PREMIUM_CONFIGURATION_KEYS,
  ServiceSelectionMode,
  UNLIMITED_CAPACITY,
  WorkerSelectionMode,
  getAllowedEnumValues,
  getCategoryFromKey,
  getConfigurationSection,
  getConfigurationType,
  getDataTypeFromKey,
  getPremiumConfigurationKeys,
  isPremiumConfiguration,
  isValidConfigurationKey,
  parseConfigurationValue,
  serializeConfigurationValue,
  validateConfigurationValue
};
//# sourceMappingURL=index.mjs.map